export const update = (w, h) => {
    return {
      type: 'UPDATE',
      payload: {
        width: w,
        height: h
      }
    }
  };